import { useHistory } from "react-router-dom";

export const ReactRouter5Adapter = ({ children }: { children: any }) => {
  const history = useHistory();

  const adapter = {
    replace(location: any) {
      history.replace(
        { ...history.location, search: location.search },
        location.state
      );
    },
    push(location: any) {
      history.push(
        { ...history.location, search: location.search },
        location.state
      );
    },
    get location() {
      return history.location;
    },
  };

  return children(adapter);
};
